//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../Mfg/Mfg.AM.PartGroup.js";
let d=[[],[[["buildStrategyNames","buildStrategyValues"],"SetBuildStrategyValues",{},2,0],[["count","buildStrategyNames","buildStrategyValues"],"GetBuildStrategyValues",{},0,0]],[]];
SPLM.Mfg.AM.Sinterbox = class extends SPLM.Mfg.AM.PartGroup{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.Sinterbox";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mfg.AM.Sinterbox.Shape = Object.freeze({
    "Box" : "Box", "Freeform" : "Freeform"});

SPLM.Mfg.AM.Sinterbox.Boundary = Object.freeze({
    "PartSelection" : "PartSelection", "IndividualParts" : "IndividualParts"});

SPLM.Mfg.AM.Sinterbox.Lattice = Object.freeze({
    "GridAndRod" : "GridAndRod", "Standard" : "Standard", "Voronoi" : "Voronoi"});

SPLM.Mfg.AM.Sinterbox.AlignmentType = Object.freeze({
    "Free" : "Free", "BuildTray" : "BuildTray"});

export default SPLM;